export default __webpack_public_path__ + "static/media/stud_billing_icon_red.e78292fc.svg";